import { EditorValue, initialValue } from 'components/TextEditor/types'
import { useLocation, useNavigate } from 'react-router-dom'
import useFormSending from './hooks/useFormSending'
import Photo from 'pages/AddProfile/steps/Photo'
import Ceremony from './steps/Ceremony'
import Template from './steps/Template'
import React, { useState } from 'react'
import TopBar from 'components/Topbar'
import Data from './steps/Data'
import './index.scss'

export type Step = {
  place: string
  address: string
  date: string
  time: string
  place_description?: string
  gps_latitude?: number
  gps_longitude?: number
}

export interface Steps {
  body_exposure?: Step
  funeral_ceremony?: Step
  burial_in_cemetery?: Step
}

export type StepKeys = keyof Steps

export interface Form {
  name: string
  birth: string
  death: string
  address: string
  content: EditorValue
  selectedImage?: File
  steps: Steps
}

export interface Errors {
  name?: string
  birth?: string
  death?: string
  address?: string
}

export type UpdateForm = (key: keyof Form, value: any) => void

const steps = ['Dane', 'Ceremonia', 'Zdjęcie', 'Szablon']

const AddObituary: React.FC = () => {
  const { state, pathname, search } = useLocation()
  const [form, setForm] = useState<Form>({
    name: '',
    birth: '',
    death: '',
    address: '',
    content: initialValue,
    steps: {}
  })
  const { isSending, submit } = useFormSending(form)

  const step = state?.step ? Number(state.step) : 0

  const navigate = useNavigate()
  const setStep = (newStep: number) => {
    navigate(`${pathname}${search}`, { state: { step: newStep } })
  }

  const updateForm: UpdateForm = (key, value) => {
    setForm(prev => ({ ...prev, [key]: value }))
  }


  return (
    <div className='addObituary'>
      <TopBar
        theme='dark'
        isSticky={false}
        title='Dodawanie nekrolog'
      />

      <div className='addObituary__steps'>
        {steps.map((name, index) => {
          return <div
            key={index}
            className={`${index === step ? 'active' : ''}`}
            onClick={() => {
              setStep(index)
            }}>
            <span>{index + 1}</span>
            <h2>{name}</h2>
          </div>
        })}
      </div>

      <div className='addObituary__content'>
        {(() => {
          switch (step) {
            case 1: return (
              <Ceremony
                form={form}
                setForm={setForm}
              />
            )

            case 2: return (
              <Photo
                selectedImage={form.selectedImage || null}
                setSelectedImage={file => {
                  updateForm('selectedImage', file)
                }}
              />
            )

            case 3: return (
              <Template
                form={form}
                updateForm={updateForm}
              />
            )

            default: return (
              <Data
                form={form}
                errors={{}}
                updateForm={updateForm}
                validate={() => { }}
              />
            )
          }
        })()}
      </div>

      <div className='addObituary__footer'>
        <button
          className={`btn btn--primary ${isSending ? 'disabled' : ''}`}
          onClick={() => {
            if (step === 3) submit()
            else setStep(step + 1)
          }}>
          {isSending ? 'Wysyłanie...' : step === 3 ? 'Zapisz' : 'Dalej'}
        </button>
      </div>
    </div>
  )
}

export default AddObituary